import axios from "axios";

/**
 * LF360-1970 — opening a server-sent stream without putting a credential in the
 * URL.
 *
 * `EventSource` cannot send headers, which is why all four streams in this app
 * pass `?token=`: an administrator's JWT, in a URL, in browser history and in
 * every proxy log between here and the server. The cookie needs none of that —
 * the browser attaches it to a same-origin stream by itself, and
 * `withCredentials` is what makes it do so when the API is on another origin,
 * as it is in local development.
 *
 * The token is still appended when one is there, and only then: a session from
 * before the cookie release has nothing else to authorise with, and its streams
 * have to keep working until it expires or the user signs in again.
 *
 * One helper rather than the same eight lines in four hooks — they had already
 * drifted into three spellings of the same comment.
 */
export const openEventSource = (path, params = {}, baseUrl = null) => {
  const base = baseUrl || axios.defaults.baseURL || "";
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value) search.append(key, value);
  });

  const legacyToken = localStorage.getItem("user_token");

  if (legacyToken) {
    search.append("token", legacyToken);
  }

  const query = search.toString() ? `?${search.toString()}` : "";

  return new EventSource(`${base}${path}${query}`, { withCredentials: true });
};

export default openEventSource;
